<h5 mat-dialog-title class="text-center">{{ 'SITE_MANAGMENT.INFO_ERROR' | translate }}</h5>

<mat-dialog-actions align="end">
  <button mat-button color="warn" mat-dialog-close [mat-dialog-close]="false" cdkFocusInitial>{{ 'SITE_MANAGMENT.CANCEL_SWAP' | translate }}</button>
</mat-dialog-actions>